import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * Reusable "Coming in next phase" placeholder. Branded, accessible.
 */
export default function PlaceholderPage({ title, description, slug }) {
    useEffect(() => {
        document.title = `${title} — AccessNova`;
    }, [title]);

    return (
        <section aria-labelledby="placeholder-heading" className="py-20 lg:py-28">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
                <span className="inline-flex items-center gap-2 rounded-full bg-brand-soft border border-brand-border px-3 py-1 text-xs font-semibold text-brand-teal">
                    <Sparkles size={14} aria-hidden="true" />
                    Coming soon
                </span>
                <h1 id="placeholder-heading" className="mt-5 text-4xl sm:text-5xl font-bold text-brand-text">
                    {title}
                </h1>
                <p className="mt-5 text-lg text-brand-body">
                    {description}
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                    <Link
                        to="/"
                        className="inline-flex items-center justify-center gap-2 rounded-md bg-brand-navy text-white font-semibold px-6 py-3 hover:bg-brand-teal transition-colors touch-target"
                        data-testid={`placeholder-${slug}-back-home`}
                    >
                        Back to homepage
                        <ArrowRight size={18} aria-hidden="true" />
                    </Link>
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center rounded-md border-2 border-brand-navy text-brand-navy font-semibold px-6 py-3 hover:bg-brand-navy hover:text-white transition-colors touch-target"
                        data-testid={`placeholder-${slug}-contact`}
                    >
                        Talk to us
                    </Link>
                </div>
            </div>
        </section>
    );
}
